module.exports = __webpack_public_path__ + "img/contact.1409b62c.png";